// extracted by mini-css-extract-plugin
export default {"hero":"orderConfirmed_hero__4j7HI","splitted":"orderConfirmed_splitted__qYh9m"};